import { render, staticRenderFns } from "./tabPageWrap.vue?vue&type=template&id=29d7d9de&scoped=true"
import script from "./tabPageWrap.vue?vue&type=script&lang=js"
export * from "./tabPageWrap.vue?vue&type=script&lang=js"
import style0 from "./tabPageWrap.vue?vue&type=style&index=0&id=29d7d9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d7d9de",
  null
  
)

export default component.exports